var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "page--login d-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('v-card', {
    staticClass: "pa-10"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "svgLogoPernambuco",
    attrs: {
      "src": "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png",
      "alt": "Brasão do state de Pernambuco"
    }
  }), _c('br'), _c('h1', {
    staticClass: "subtitle-1 blue--text text--darken-4",
    attrs: {
      "color": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.$appName || 'Acessar o Sistema')
    }
  })])], 1), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "text-center"
  }, [_c('h4', {
    staticClass: "subtitle-2 blue--text",
    attrs: {
      "color": "primary"
    },
    domProps: {
      "textContent": _vm._s('Primeiro Acesso')
    }
  })])])], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Nova senha",
      "maxlength": "8",
      "append-icon": _vm.form.senha.show ? 'mdi-eye-off' : 'mdi-eye',
      "type": _vm.form.senha.show ? 'text' : 'password',
      "rules": _vm.regrasDaSenha
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.enter.apply(null, arguments);
      },
      "click:append": function ($event) {
        _vm.form.senha.show = !_vm.form.senha.show;
      }
    },
    model: {
      value: _vm.form.senha.value,
      callback: function ($$v) {
        _vm.$set(_vm.form.senha, "value", $$v);
      },
      expression: "form.senha.value"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Confirme a nova senha",
      "maxlength": "8",
      "append-icon": _vm.form.confirmacaoSenha.show ? 'mdi-eye-off' : 'mdi-eye',
      "type": _vm.form.confirmacaoSenha.show ? 'text' : 'password',
      "rules": _vm.regrasDaSenha
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.enter.apply(null, arguments);
      },
      "click:append": function ($event) {
        _vm.form.confirmacaoSenha.show = !_vm.form.confirmacaoSenha.show;
      },
      "paste": function ($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.form.confirmacaoSenha.value,
      callback: function ($$v) {
        _vm.$set(_vm.form.confirmacaoSenha, "value", $$v);
      },
      expression: "form.confirmacaoSenha.value"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-card', [_c('span', [_vm._v("Sua senha deve ter 8 caracteres e ser composta por pelo menos:")]), _c('ul', {
    staticClass: "mt-1"
  }, _vm._l(_vm.getInformacoesDasRegras(), function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "mt-2"
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "color": item.valid(_vm.form) ? 'success' : 'warning'
      }
    }, [_vm._v(" " + _vm._s(item.icon(item.valid(_vm.form))) + " ")]), _vm._v(" " + _vm._s(item.text) + " ")], 1);
  }), 0)])], 1)], 1), _c('v-row', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "success",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.enviar.apply(null, arguments);
      }
    }
  }, [_vm._v(" Enviar ")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info",
      "small": "",
      "rounded": "",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.voltar.apply(null, arguments);
      }
    }
  }, [_vm._v("Voltar")])], 1)], 1)], 1)], 1)], 1)])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }